import React, { FC, Fragment, useEffect, useState, useRef } from 'react'
import SecondPhase from './SecondPhase'
import { Form, Formik } from 'formik'
import { InitialValuesForCreateProduct } from 'src/interfaces/createProductInterface'
import Loader from 'src/utils/Loader'
import VariantComponent from './VariantComponent'

import { useAppDispatch, useAppSelector } from 'src/redux/storeHooks'
import { adjustVariantInventoryAsync, createOptionNameAsync, createProductAsync, createProductCustomFieldAsync, getCollectionsAsync, getEditProductAsync, getEditProductCustomFieldsAsync, getInventoryDetailsAsync, getOptionNamesAsync, SaveVariantAsync, updateProductAsync, uploadUserGalleryAsync, getCategoryByIdAsync, getAllVariantsAsync } from 'src/redux/actions/omsProductActions'
import { toast } from 'react-toastify'
import { getFieldTreeSearchAsync, getPlatformChildFieldDataCategoriesAsync, getPlatformParentFieldDataCategoriesAsync } from 'src/redux/actions/templateAndPricingActions'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import FirstPhase, { ProductMediaSection } from './FirstPhase'
import { buildCustomFieldsPayloadForCreate, buildCustomFieldsPayloadForEdit, buildOptionsValuesPayload, detectHasVariant, getApiErrorMessage, mapInventoryToFormikValues, parseCheckboxValue, ensureNonNegative } from 'src/marketConnect/helpers'
import ProductCustomFields from './ProductCustomFields'
import { id } from 'date-fns/locale'
import { usePlatformBackUrl } from 'src/hooks/usePlatformBackUrl'
import PremiumBreadcrumb from 'src/app/components/navigation/PremiumBreadcrumb'

const initialValues: InitialValuesForCreateProduct = {
  name: '',
  description: "",
  basePrice: '',
  image_set: [],
  options: [],
  varients_data: [],
  selectedStatus: 'DRAFT',
  scheduledDateTime: '',
  selectedOptions: [],
  selectedValues: [],
  inputValue: '',
  productTemplate: '',
  selectedTagValues: [],
  product_name: '',
  barcode: '',
  shelfQuantity: '',
  warehouseQuantity: '',
  allowBackorders: false,
  selectedImages: [],
  weeklySales: 0,
  genralDescription: '',
  discountType: '1', // Set default discount type here
  discount_percentage: '',
  discount_fixed_price: '',
  tax: '0', // Set default tax option here
  vat_amount: '',
  sku: '',
  ean: '',
  advanceDescription: '',
  weight: '',
  weightUnit: 'KGS',
  length: '',
  width: '',
  height: '',
  dimensionUnit: 'CM',
  meta_title: '',
  add_product_meta_keywords: '',
  vendor: [],
  collection: [],
  category: null,
  inventory: [],
  custom_fields: {},
  type: "",
  comparePrice: '',
  salePrice: '',
  costPrice: '',
  product_custom_fields_raw: [],
  reorder_point_id: null,
  reorder_point_value: 1,
  isProductHasVariant: false
}
export interface RowDataItem {
  id: string;
  platform_product: {
    id: number;
  }
}
export interface CreateEditState {
  mode: "create" | "edit"; rowData?: RowDataItem; platformId?: number;
}

const OldCreateProduct: FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const state = location.state as CreateEditState | undefined;
  const isUpdateRoute = location.pathname.startsWith('/update-product');

  const { fetchedConnectedPlatformData, omsStoreData, mainStoreData } = useAppSelector(
    (state) => state.fetchConnectedPlatform
  );

  const effectivePlatformId = state?.platformId ?? params.platformId;
  const fallbackPlatformId = omsStoreData?.id ?? mainStoreData?.id ?? fetchedConnectedPlatformData?.[0]?.id;
  const currentPlatformId = effectivePlatformId
    ? Number(effectivePlatformId)
    : (fallbackPlatformId ? Number(fallbackPlatformId) : undefined);

  // expected: /update-product/platform/4426/productId/5426735
  const productIdFromPath = React.useMemo(() => {
    if (!isUpdateRoute) return undefined;

    const match = location.pathname.match(/\/productId\/(\d+)/i);
    if (!match?.[1]) return undefined;

    return Number(match[1]);
  }, [isUpdateRoute, location.pathname]);

  // mode priority: URL update route -> edit, else state.mode -> create
  const mode: "create" | "edit" = isUpdateRoute ? "edit" : (state?.mode ?? "create");

  // product id priority: URL -> state.rowData -> undefined
  const resolvedProductId = React.useMemo(() => {
    if (productIdFromPath) return productIdFromPath;
    if (state?.rowData?.id) {
      return Number(state.rowData.id);
    }
    return undefined;
  }, [productIdFromPath, state]);

  // keep rowData if exists (optional)
  const rowData = state?.rowData;

  const paramPlatformId = params.platformId;
  const backUrl = usePlatformBackUrl(currentPlatformId);
  const currentPlatformName = React.useMemo(() => {
    const matchedPlatform = fetchedConnectedPlatformData?.find(
      (platform: any) => Number(platform?.id) === Number(currentPlatformId)
    )

    const platformType = String(
      matchedPlatform?.type ||
        matchedPlatform?.platform_info?.type ||
        matchedPlatform?.platform_info?.nature ||
        ''
    )
      .trim()
      .toUpperCase()
    const platformName = String(
      matchedPlatform?.name || matchedPlatform?.platform_info?.name || ''
    )
      .trim()
      .toUpperCase()
    const isOmsPlatform =
      Boolean(matchedPlatform?.isOmsStore) ||
      platformType === 'OMS' ||
      platformName === 'COMMERCIUMOMS'

    if (isOmsPlatform) return 'Master Products'

    return (
      matchedPlatform?.platform_info?.display_name ??
      matchedPlatform?.display_name ??
      matchedPlatform?.name ??
      'All Products'
    )
  }, [currentPlatformId, fetchedConnectedPlatformData])
  const [editInitialValues, setEditInitialValues] = useState<InitialValuesForCreateProduct>(initialValues);
  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isSavingProduct, setIsSavingProduct] = useState(false);
  const isSavingProductRef = useRef(false);
  const [getEditData, setGetEditData] = useState(false);

  const { customFieldsList, pagination, loading } = useSelector((state: any) => state.omsCustomFieldsSlice);
  const productId = resolvedProductId;
  const [editInventoryData, setEditInventoryData] = useState<any[]>([]);

  const buildCustomFieldsInitialValues = (
    productCustomFields: any[] = [],
    customFieldsList: any[] = []
  ) => {
    const metaById = new Map<number, any>();
    (customFieldsList || []).forEach((f: any) => metaById.set(Number(f.id), f));

    const out: Record<string, any> = {};

    for (const row of productCustomFields) {
      const fieldId = Number(row?.platform_field ?? row?.platform_field_id ?? row?.field_id);
      if (!fieldId) continue;

      const type = metaById.get(fieldId)?.input_type;
      const dataId = row?.platform_field_data_id ?? row?.platform_field_data;
      const value = row?.value ?? row?.api_name ?? "";

      if (type === "MULTISELECT") {
        // Accumulate values across multiple rows for the same field
        const curr = Array.isArray(out[fieldId]) ? out[fieldId] : [];
        let ids = row?.platform_field_data_ids ?? dataId;
        if (typeof ids === "string") {
          ids = ids.split(",").map((x: string) => x.trim()).filter(Boolean).map((x: string) => Number(x));
        } else if (Array.isArray(ids)) {
          ids = ids.map((x: any) => Number(x)).filter((n: any) => !Number.isNaN(n));
        } else if (ids != null) {
          ids = [Number(ids)].filter((n: any) => !Number.isNaN(n));
        } else {
          ids = [];
        }
        // Deduplicate — backend may return duplicate IDs
        out[fieldId] = [...new Set([...curr, ...ids])];
        continue;
      }

      if (type === "SELECT") {
        out[fieldId] = dataId ? Number(dataId) : "";
        continue;
      }

      if (type === "CHECKBOX") {
        out[fieldId] = parseCheckboxValue(value);
        continue;
      }
      out[fieldId] = value ?? "";
    }
    return out;
  };

  const mapApiOptionsToFormik = (apiData: any): any[] => {
    if (!apiData || typeof apiData !== "object") return [];

    const mapped = Object.entries(apiData).map(([optionName, optObj]: any) => {
      const valuesArr = Array.isArray(optObj?.values) ? optObj.values : [];

      const values = valuesArr
        .map((v: any) => String(v?.value ?? "").trim()).filter(Boolean);

      const value_ids = valuesArr.reduce((acc: any, v: any) => {
        const key = String(v?.value ?? "").trim();
        if (key && v?.id) acc[key] = Number(v.id);
        return acc;
      }, {});

      return {
        id: optObj?.id ? Number(optObj.id) : undefined,
        name: String(optionName).trim(),
        position: optObj?.position !== undefined ? Number(optObj.position) : undefined,
        values,
        value_ids,
      };
    });

    return mapped.sort((a, b) => (a.position ?? 999) - (b.position ?? 999));
  };

  const getOptionValuesAsStrings = (opt: any): string[] => {
    if (Array.isArray(opt?.values)) {
      return opt.values.map((v: any) => String(typeof v === "object" && v !== null ? (v.value ?? "") : v));
    }

    if (Array.isArray(opt?.option_values)) {
      return opt.option_values.map((v: any) => String(v?.value ?? ""));
    }

    return [];
  };

  const parseVariantNameOptionValues = (variantName: any, options: any[]): string[] => {
    if (!variantName || !(options || []).length) return [];

    const nameParts = String(variantName)
      .split("/")
      .map((p) => p.trim())
      .filter(Boolean);

    if (!nameParts.length) return [];

    const namedValues: string[] = [];
    let matchedNamedParts = 0;

    (options || []).forEach((opt: any) => {
      const optName = String(opt?.name || opt).trim().toLowerCase();
      const matchingPart = nameParts.find((p) => p.toLowerCase().startsWith(`${optName}:`));

      if (matchingPart) {
        const value = matchingPart.substring(matchingPart.indexOf(":") + 1).trim();
        const validValues = getOptionValuesAsStrings(opt)
          .map((v) => String(v ?? "").trim().toLowerCase().replace(/[^a-z0-9]+/g, ""));

        if (!validValues.length || validValues.includes(String(value ?? "").trim().toLowerCase().replace(/[^a-z0-9]+/g, ""))) {
          matchedNamedParts += 1;
          namedValues.push(value);
        }
      }
    });

    if (matchedNamedParts === options.length) return namedValues;

    const positionalValues: string[] = [];
    const usedPartIndexes = new Set<number>();

    (options || []).forEach((opt: any) => {
      const optVals = getOptionValuesAsStrings(opt).map((v) => String(v).trim().toLowerCase());
      const matchingIndex = nameParts.findIndex((p, index) =>
        !usedPartIndexes.has(index) && optVals.includes(p.toLowerCase())
      );

      if (matchingIndex !== -1) {
        usedPartIndexes.add(matchingIndex);
        positionalValues.push(nameParts[matchingIndex]);
      }
    });

    if (positionalValues.length === options.length) return positionalValues;

    if (nameParts.length === options.length) {
      return nameParts.map((part) => {
        const colonIndex = part.indexOf(":");
        return colonIndex !== -1 ? part.substring(colonIndex + 1).trim() : part;
      });
    }

    return [];
  };

  const parseOptionValues = (
    variant: any,
    options: any[],
    optionValueIdMap: Record<number, string>
  ): string[] => {
    const slots = [
      variant?.platform_product_option_value1,
      variant?.platform_product_option_value2,
      variant?.platform_product_option_value3,
    ].filter(Boolean)
  
    if (slots.length > 0) {
      const slotMap: Record<string, string> = {}
      slots.forEach((slot: any) => {
        const val = typeof slot === 'object' ? (slot.value ?? optionValueIdMap[Number(slot.id)]) : optionValueIdMap[Number(slot)]
        const optName = typeof slot === 'object' ? slot.option_name : null
        if (optName && val) {
          slotMap[String(optName).trim().toLowerCase()] = val
        }
      })
  
      if (Object.keys(slotMap).length > 0) {
        const mappedValues = (options || []).map((opt: any) => {
          const optName = String(opt?.name || opt).trim().toLowerCase()
          return slotMap[optName] || ""
        })
        if (mappedValues.some(v => v !== "")) {
          return mappedValues
        }
      }
  
      const slotValues: string[] = []
      slots.forEach((slot: any) => {
         const val = typeof slot === 'object' ? (slot.value ?? optionValueIdMap[Number(slot.id)]) : optionValueIdMap[Number(slot)]
         if (val) slotValues.push(val)
      })
      if (slotValues.length > 0 && slotValues.length === (options || []).length) {
         return slotValues
      }
    }
  
    const valuesFromName = parseVariantNameOptionValues(variant?.name, options);
    if (valuesFromName.length === (options || []).length) {
      return valuesFromName;
    }

    return [variant?.name ?? ''];
  };

  const extractCategoryFromResponse = (res: any) => {
    const candidates = [
      res?.results?.data,
      res?.data?.results?.data,
      res?.data?.data,
      res?.data,
      res,
    ];

    for (const candidate of candidates) {
      if (Array.isArray(candidate) && candidate.length) return candidate[0];
      if (candidate && typeof candidate === "object" && (candidate.api_name || candidate.name || candidate.id)) {
        return candidate;
      }
    }

    return null;
  };

  const mapProductToFormikValues = (p: any, cfRows?: any[], variantsForHydration?: any[]): InitialValuesForCreateProduct => {
    const firstVariant = p?.variants?.[0];
    const isProductHasVariant = detectHasVariant(p);
    const rawCustomFields = Array.isArray(cfRows) ? cfRows : (p?.product_custom_fields || []);

    return {
      ...initialValues,

      name: p?.name ?? "",
      description: p?.description ?? "",
      genralDescription: p?.short_description ?? "",
      selectedStatus: p?.api_status ? p.api_status.toUpperCase() : "DRAFT",
      type: p?.product_type ?? "",

      // images keep id
      selectedImages: [...(p?.images || [])]
        .sort((a: any, b: any) => {
          const posA = Number(a?.image_position ?? 999999)
          const posB = Number(b?.image_position ?? 999999)
          return posA - posB
        })
        .map((img: any) => ({
          fileName: `server-${img.id}`,
          imageUrl: img.image_url,
          url: img.image_url,
          id: img.id,
          size: 0,
          type: "image/*",
          position: Number(img.image_position ?? 0),
        })),

      isProductHasVariant,

      salePrice: ensureNonNegative(firstVariant?.price?.value ?? 0),
      comparePrice: ensureNonNegative(firstVariant?.compare_price?.value ?? 0),
      costPrice: ensureNonNegative(firstVariant?.cost_price?.value ?? 0),
      weight: ensureNonNegative(firstVariant?.weight?.value ?? 0),
      weightUnit: firstVariant?.weight?.unit ?? "KGS",
      length: ensureNonNegative(firstVariant?.length?.api_id ?? ''),
      width: ensureNonNegative(firstVariant?.width?.api_id ?? ''),
      height: ensureNonNegative(firstVariant?.height?.api_id ?? ''),
      dimensionUnit: firstVariant?.dimention_unit?.api_id ?? 'CM',

      vendor: p?.vendor ?? "",
      selectedTagValues: (p?.tags || []).map((t: string) => ({ label: t, value: t })),

      //  category — hydrate from BE response if available (defensive mapping)
      //  BE may return: { id, name } OR { category_id, api_name } — handle both
      ...((): any => {
        const cat = p?.category;
        // resolve the raw id — prefer category_id as it represents the true OMS category ID
        const rawId = cat?.category_id ?? cat?.platform_field_data ?? cat?.id ?? null;
        if (!rawId) return {};

        // resolve display name — BE may use .name or .api_name
        const catName = cat?.name ?? cat?.api_name ?? String(rawId);
        const depth = Number(cat?.depth ?? 0);

        // relation id is the DB record id of the product category link
        // category_id (rawId) is the actual category identifier
        const relationId = cat?.id ?? null;

        return {
          __categoryV2: {
            id: String(rawId),
            relationId: relationId != null ? Number(relationId) : null,
            name: catName,
            has_child: Boolean(cat?.has_child),
            depth,
            parentId: cat?.parent_id ? String(cat.parent_id) : null,
            raw: cat,
          },
          category: {
            value: String(rawId),
            label: catName,
            level: (depth === 0 ? "parent" : "child") as "parent" | "child",
            parentId: cat?.parent_id ? String(cat.parent_id) : undefined,
          },
        };
      })(),

      //  collections include relation id (collections[i].id) + value (platform_field_data)
      collection: (p?.collections || []).map((c: any) => ({
        id: c.id, // IMPORTANT for update
        value: c.platform_field_data,
        label: c.api_name || "",
      })),

      //  keep raw for update building if needed
      product_custom_fields_raw: rawCustomFields,
      //  custom_fields form object
      custom_fields: buildCustomFieldsInitialValues(rawCustomFields, customFieldsList),

      options: [],

      reorder_point_id: p?.reorder_point?.id ?? null,
      reorder_point_value: ensureNonNegative(p?.reorder_point?.api_id ?? 1),

      varients_data: (() => {
        // Build a lookup map: option_value_id → value string
        // from the product-level options dictionary.
        // Shape: options = { "Color": { values: [{id:42079, value:"RED"}, ...] }, ... }
        const optionValueIdMap: Record<number, string> = {};
        const productOptions = p?.options;
        if (productOptions && typeof productOptions === 'object') {
          Object.values(productOptions).forEach((optObj: any) => {
            const vals = Array.isArray(optObj?.values) ? optObj.values : [];
            vals.forEach((v: any) => {
              if (v?.id != null && v?.value != null) {
                optionValueIdMap[Number(v.id)] = String(v.value);
              }
            });
          });
        }

        const currentOptions = mapApiOptionsToFormik(p?.options);
        const activeVariants = Array.isArray(variantsForHydration) ? variantsForHydration : (p?.variants || []);

        return activeVariants.map((v: any, i: number) => {
          const optionValues = parseOptionValues(v, currentOptions, optionValueIdMap);

          return {
            _index: i,
            variant_id: v?.id,
            optionValues,
            price: String(ensureNonNegative(v?.price?.value ?? "")),
            costPrice: String(ensureNonNegative(v?.cost_price?.value ?? "")),
            available: v?.total_available_quantity || "",
            sku: v?.sku ?? "",
            barcode: v?.barcode ?? "",
            ean: v?.ean ?? "",
            name: v?.name ?? "",
            reorder_point: "",
            isTracked: Boolean(v?.isTracked) || false,
            variant_image: v?.image?.image_url
              ? {
                fileName: `server-variant-${v.image.id}`,
                imageUrl: v.image.image_url,
                url: v.image.image_url,
                id: v.image.id,
              } : null,
          };
        });
      })(),
      inventory: [],
    };
  };


  useEffect(() => {
    if (mode !== "edit") return;
    if (!productId) return;

    let cancelled = false;

    const run = async () => {
      setIsPageLoading(true);

      try {
        // 1) GET PRODUCT
        const productRes: any = await dispatch(
          getEditProductAsync({ id: Number(productId) })
        ).unwrap();

        const productStatus = Number(productRes?.status);
        if (
          productRes?.status !== undefined &&
          productStatus !== 200 &&
          productStatus !== 201
        ) {
          toast.error(getApiErrorMessage(productRes, "Failed to load product"));
          return;
        }

        const product = productRes?.data;
        if (!product) {
          toast.error("Failed to load product");
          return;
        }

        // GET ALL VARIANTS FOR HYDRATION
        let variantsFromApi: any[] = [];
        try {
          const variantsRes: any = await dispatch(
            getAllVariantsAsync({ id: Number(productId) })
          ).unwrap();
          
          if (Array.isArray(variantsRes)) {
            variantsFromApi = variantsRes;
          } else if (Array.isArray(variantsRes?.data)) {
            variantsFromApi = variantsRes.data;
          } else if (Array.isArray(variantsRes?.data?.variants)) {
            variantsFromApi = variantsRes.data.variants;
          }
        } catch (e) {
          console.error("Failed to fetch variants from api", e);
        }

        if (product && variantsFromApi.length > 0) {
          product.variants = variantsFromApi;
        }

        // GET CATEGORY DETAILS IF MISSING
        const categoryIdToFetch = product?.category?.category_id ?? product?.category?.platform_field_data;
        const currentCategoryName = product?.category?.name ?? product?.category?.api_name;
        const shouldFetchCategoryName =
          product?.category &&
          categoryIdToFetch &&
          (!currentCategoryName || String(currentCategoryName) === String(categoryIdToFetch));

        if (shouldFetchCategoryName) {
          try {
            const catRes: any = await dispatch(getCategoryByIdAsync({ id: Number(categoryIdToFetch) })).unwrap();
            const catData = extractCategoryFromResponse(catRes);
            if (catData) {
              const categoryName = catData.name || catData.api_name;
              if (categoryName) {
                product.category.name = categoryName;
                product.category.api_name = categoryName;
              }
              product.category.has_child = catData.has_child;
              product.category.depth = catData.depth;
              product.category.parent_id = catData.parent_id ?? catData.parent_data;
            }
          } catch (e) {
            console.error("Failed to fetch category details", e);
          }
        }

        if (cancelled) return;
        setGetEditData(product);

        // defaults
        let formikInventoryRows: InitialValuesForCreateProduct["inventory"] = [];
        let normalizedInvRows: any[] = [];
        let cfRows: any[] = [];
        let formikOptions: any[] = [];

        // 2) GET INVENTORY
        const variant_ids = (product?.variants ?? [])
          .map((v: any) => v?.id)
          .filter(Boolean)
          .join(",");

        if (variant_ids) {
          const invRes: any = await dispatch(
            getInventoryDetailsAsync({
              page: 1,
              limit: 10,
              sort_by: "desc",
              order_by: "id",
              variant_ids,
            })
          ).unwrap();

          const invStatus = Number(invRes?.status);
          if (
            invRes?.status !== undefined &&
            invStatus !== 200 &&
            invStatus !== 201
          ) {
            toast.error(getApiErrorMessage(invRes, "Failed to load inventory"));
          } else {
            const invRows =
              invRes?.results?.data ||
              invRes?.data?.results?.data ||
              invRes?.data ||
              [];

            normalizedInvRows = Array.isArray(invRows) ? invRows : [];
            formikInventoryRows = mapInventoryToFormikValues(normalizedInvRows);

            if (!cancelled) {
              setEditInventoryData(normalizedInvRows);
            }
          }
        }

        // 3) GET PRODUCT CUSTOM FIELDS
        const cfRes: any = await dispatch(
          getEditProductCustomFieldsAsync({ productId: Number(productId) })
        ).unwrap();

        const cfStatus = Number(cfRes?.status);
        if (
          cfRes?.status !== undefined &&
          cfStatus !== 200 &&
          cfStatus !== 201
        ) {
          toast.error(
            getApiErrorMessage(cfRes, "Failed to load product custom fields")
          );
        } else {
          cfRows =
            cfRes?.data?.results?.data ??
            cfRes?.results?.data ??
            cfRes?.data ??
            [];
        }

        if (cancelled) return;

        // 4) GET OPTIONS
        const optRes: any = await dispatch(
          getOptionNamesAsync({ productId: Number(productId) })).unwrap();

        const optStatus = Number(optRes?.status);
        if (optStatus !== 200 && optStatus !== 201) {
          toast.error(getApiErrorMessage(optRes, "Failed to load options"));
        } else {
          formikOptions = mapApiOptionsToFormik(optRes?.data);
          // if actual response shape is nested, use:
          // formikOptions = mapApiOptionsToFormik(optRes?.data?.data);
        }

        // 5) BUILD FINAL INITIAL VALUES ONLY ONCE
        const baseValues = mapProductToFormikValues(
          product,
          Array.isArray(cfRows) ? cfRows : [],
          product?.variants
        );

        if (cancelled) return;

        setEditInitialValues({
          ...baseValues,
          inventory: formikInventoryRows,
          options: formikOptions,
        });
      } catch (err: any) {
        toast.error(getApiErrorMessage(err));
      } finally {
        if (!cancelled) {
          setIsPageLoading(false);
        }
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [mode, productId, dispatch, customFieldsList?.length]);

  const buildVariantInventory = (values: any) => {
    const inv = values.inventory || [];
    return inv.filter((x: any) => x?.id && x?.quantity !== undefined)
      .map((x: any) => ({
        warehouse_id: Number(x.id),
        opening_quantity: Number(x.quantity) || 0,
      }));
  };

  const buildCustomFieldsPayloadAll = (
    customFieldsObj: Record<string, any>,
    customFieldsList: any[]
  ) => {
    if (!customFieldsObj) return [];

    const metaById = new Map<number, any>();
    (customFieldsList || []).forEach((f: any) => metaById.set(Number(f.id), f));

    const result: any[] = [];

    Object.entries(customFieldsObj).forEach(([fieldIdStr, raw]) => {
      const fieldId = Number(fieldIdStr);
      const meta = metaById.get(fieldId);
      const type = meta?.input_type;

      if (type === "MULTISELECT") {
        const ids = Array.isArray(raw) ? raw : [];

        result.push({
          platform_field_id: String(fieldId),
          platform_field_data_ids: ids.map(Number).filter((n) => !Number.isNaN(n)),
          value: "",
        });
        return;
      }

      if (type === "SELECT") {
        result.push({
          platform_field_id: String(fieldId),
          platform_field_data_id: raw ? String(raw) : null,
          value: "",
        });
        return;
      }

      if (type === "CHECKBOX") {
        result.push({
          platform_field_id: String(fieldId),
          platform_field_data_id: null,
          value: parseCheckboxValue(raw),
        });
        return;
      }

      result.push({
        platform_field_id: String(fieldId),
        platform_field_data_id: null,
        value: raw === null || raw === undefined ? "" : String(raw),
      });
    });

    return result;
  };

  const sumInventoryQty = (values: any) => {
    return (values.inventory || []).reduce(
      (sum: number, x: any) => sum + (Number(x.quantity) || 0),
      0);
  };

  const buildCreateProductPayload = (values: any, mode: "create" | "edit") => {
    // Create filename → url map (keep if you later fill it after uploads)
    const fileUrlMap = new Map<string, string>();
    // isTracked depends on isProductHasVariant
    const isTracked = Boolean(values?.isProductHasVariant);
    // Build inventory once
    const variantInventory = buildVariantInventory(values);
    // ---- Product Images (preserve order) + include id in edit
    const productImages = (values.selectedImages || [])
      .map((img: any, index: number) => {
        const uploadedUrl = fileUrlMap.get(img.fileName);
        const finalUrl = uploadedUrl || img.url || img.imageUrl;
        if (!finalUrl) return null;
        return {
          ...(mode === "edit" && img.id ? { id: Number(img.id) } : {}),
          image_url: finalUrl,
          image_position: index + 1,
        };
      })
      .filter(Boolean);
    // First product image for single-variant mode
    const firstSelectedProductImageUrl =
      values?.selectedImages?.[0]?.url ||
      values?.selectedImages?.[0]?.imageUrl ||
      null;

    const variantDimensions = [
      { length: String(values.length ?? "") },
      { width: String(values.width ?? "") },
      { height: String(values.height ?? "") },
    ];

    // ---- Variants
    const variants = values?.isProductHasVariant
      ? (values.varients_data || []).map((variant: any) => {
        const variantFileName = variant?.variant_image?.fileName;
        const uploadedVariantUrl = variantFileName ? fileUrlMap.get(variantFileName) : undefined;

        const existingVariantUrl = variant?.variant_image?.url || variant?.variant_image?.imageUrl;
        const finalVariantUrl = uploadedVariantUrl || existingVariantUrl;

        // Build the option_value map from this variant's optionValues array
        // Each entry maps option_name -> selected value for this specific variant row
        const optionValueMap: Record<string, string> = {};
        (values.options || []).forEach((opt: any, index: number) => {
          const val = variant.optionValues?.[index];
          if (opt?.name && val) {
            optionValueMap[opt.name] = val;
          }
        });

        // Rebuild name: "OptionName: OptionValue / OptionName: OptionValue"
        const nameParts: string[] = [];
        (values.options || []).forEach((opt: any, optIdx: number) => {
          const val = variant.optionValues?.[optIdx];
          if (opt?.name && val) {
            nameParts.push(`${opt.name}: ${val}`);
          }
        });
        const variantName = nameParts.join(' / ');

        return {
          id: variant?.variant_id ? Number(variant.variant_id) : undefined,
          name: variantName || undefined,
          barcode: variant.barcode || "",
          mpn: "",
          isbn: "",
          ean: variant.ean || "",
          sku: variant.sku || "",
          isActive: true,
          position: Number(variant._index ?? 0) + 1,
          isTracked: variant?.isTracked,

          sell_price: Number(variant.price) || 0,
          cost_price: Number(variant.costPrice) || 0,
          compare_price: Number(values.comparePrice) || 0,
          weight: Number(values.weight) || 0,
          weight_unit: values.weightUnit || "",
          reorder_point: Number(variant.reorder_point) || 0,
          quantity: Number(variant.available) || 0,

          dimensions: variantDimensions,
          dimensions_unit: values.dimensionUnit || "",

          option_value: optionValueMap,

          variant_images: finalVariantUrl ? [{ image_position: null, image_url: finalVariantUrl }] : [],
        };
      })
      : [{
        // Single-variant mode payload
        barcode: values?.varients_data[0]?.barcode || "",
        mpn: "",
        isbn: "",
        ean: values?.varients_data[0]?.ean || "",
        sku: values?.varients_data[0]?.sku || "",
        isActive: true,
        position: 1,
        isTracked: values?.varients_data[0]?.isTracked,

        sell_price: Number(values.salePrice) || 0,
        cost_price: Number(values.costPrice) || 0,
        compare_price: Number(values.comparePrice) || 0,
        weight: Number(values.weight) || 0,
        weight_unit: values.weightUnit || "",
        reorder_point: Number(values.reorder_point_value) || 0,
        quantity: sumInventoryQty(values),

        dimensions: variantDimensions,
        dimensions_unit: values.dimensionUnit || "",
        option_value: {},
        // use first product image as variant image
        variant_images: firstSelectedProductImageUrl ? [{ image_position: null, image_url: firstSelectedProductImageUrl }] : [],
      },
      ];

    // ---- Build the product-level payload ----
    // Shared fields (used by both create & update)
    const shared: Record<string, any> = {
      name: values.name,
      description: values.description?.replace(/<[^>]*>/g, ""),
      short_description: values.genralDescription || "",
      product_type: values.type || "",
      custom_fields: [],
      brand: {},
    };

    if (mode === "create") {
      // CREATE-only: matches POST /oms/products contract
      return {
        ...shared,
        // product-level fields the create API accepts
        product_status: values.selectedStatus?.toUpperCase() || "",
        vendor: Array.isArray(values.vendor) ? values.vendor?.[0] || "" : values.vendor || "",
        tags: values.selectedTagValues?.map((t: any) => t.value) || [],
        isActive: true,
        product_images: productImages,
        option_values: (values.options || []).reduce((acc: any, opt: any) => {
          acc[opt.name] = opt.values;
          return acc;
        }, {}),
        variants,
        collections: (values.collection || []).map((c: any) => ({
          platform_field_data_id: Number(c.value) || [],
        })) || [],
        category: (() => {
          const rawV2Id = values.__categoryV2?.id;
          const catId = (rawV2Id !== null && rawV2Id !== undefined && rawV2Id !== '')
            ? Number(rawV2Id)
            : (values.category ? Number(values.category.value) : null);
          if (!catId) return {};
          return { category_id: catId };
        })(),
        reorder_point: {
          reorder_point_value: Number(values.reorder_point_value ?? 1),
        },
      };
    }

    // UPDATE-only: matches PATCH /oms/products/{id}
    return {
      ...shared,
      product_status: values.selectedStatus?.toUpperCase() || "",
      vendor: Array.isArray(values.vendor) ? values.vendor?.[0] || "" : values.vendor || "",
      tags: values.selectedTagValues?.map((t: any) => t.value) || [],
      reorder_point: {
        ...(values.reorder_point_id ? { id: Number(values.reorder_point_id) } : {}),
        reorder_point_value: Number(values.reorder_point_value ?? 1),
      },
      isActive: true,
      product_images: productImages,
      option_values: (values.options || []).reduce((acc: any, opt: any) => {
        acc[opt.name] = opt.values;
        return acc;
      }, {}),
      weight: Number(values.weight) || 0,
      weight_unit: values.weightUnit || "",
      collections: (values.collection || []).map((c: any) => ({
        ...(c.id ? { id: Number(c.id) } : {}),
        platform_field_data_id: Number(c.value) || [],
      })) || [],
      category: (() => {
        const rawV2Id = values.__categoryV2?.id;
        const catId = (rawV2Id !== null && rawV2Id !== undefined && rawV2Id !== '')
          ? Number(rawV2Id)
          : (values.category ? Number(values.category.value) : null);
        const relationId = values.__categoryV2?.relationId ?? null;

        if (!catId) return {};

        return {
          ...(relationId != null ? { id: Number(relationId) } : {}),
          category_id: catId,
        };
      })(),
    };
  };

  const buildSaveVariantPayloadLegacy = (values: any, editProduct: any) => {
    const backendVariants = editProduct?.variants || [];
    const currentOptions = values.options || [];

    const optionValueIdMap: Record<number, string> = {};
    const productOptions = editProduct?.options;
    if (productOptions && typeof productOptions === 'object') {
      Object.values(productOptions).forEach((optObj: any) => {
        const vals = Array.isArray(optObj?.values) ? optObj.values : [];
        vals.forEach((val: any) => {
          if (val?.id != null && val?.value != null) {
            optionValueIdMap[Number(val.id)] = String(val.value);
          }
        });
      });
    }

    const formikVariantsMap = new Map<number, any>();
    (values.varients_data || []).forEach((fv: any) => {
      if (fv.variant_id) {
        formikVariantsMap.set(Number(fv.variant_id), fv);
      }
    });

    // --- SECTION 1: SLOT ASSIGNMENT ---
    const slotAssignments: { id: number | null, name: string | null }[] = [
      { id: null, name: null },
      { id: null, name: null },
      { id: null, name: null },
    ];

    // Try to detect slot assignments from existing backend variants first
    backendVariants.forEach((v: any) => {
      [1, 2, 3].forEach((slotNum) => {
        const slot = v[`platform_product_option_value${slotNum}`];
        if (slot) {
          const slotOptId = Number(slot.platform_product_option);
          const slotOptName = slot.option_name ? String(slot.option_name) : null;
          if (slotOptId && !slotAssignments[slotNum - 1].id) {
            slotAssignments[slotNum - 1] = { id: slotOptId, name: slotOptName };
          }
        }
      });
    });

    // RESYNC: For options present in currentOptions but not yet mapped, assign to first available slot
    currentOptions.forEach((opt: any) => {
      const optId = opt.id ? Number(opt.id) : null;
      const optName = opt.name ? String(opt.name) : null;

      const isAlreadyAssigned = slotAssignments.some(
        (s) => s.id === optId || (optName && s.name?.toLowerCase() === optName.toLowerCase())
      );

      if (!isAlreadyAssigned) {
        const emptySlotIdx = slotAssignments.findIndex((s) => s.id === null && s.name === null);
        if (emptySlotIdx !== -1) {
          slotAssignments[emptySlotIdx] = { id: optId, name: optName };
        }
      }
    });

    // --- SECTION 3: OPTIONS & VALUES DELETED MATCHING ---
    const deletedOptionIds = new Set<number>();
    const deletedOptionValueIds = new Set<number>();
    const backendOptions = editProduct?.options || {};

    Object.entries(backendOptions).forEach(([optName, optObj]: any) => {
      const backendOptId = Number(optObj?.id);
      if (!backendOptId) return;

      const currentOpt = currentOptions.find(
        (o: any) => Number(o.id) === backendOptId || String(o.name).toLowerCase() === optName.toLowerCase()
      );

      if (!currentOpt) {
        deletedOptionIds.add(backendOptId);
      } else {
        const backendValues = Array.isArray(optObj?.values) ? optObj.values : [];
        const currentVals = Array.isArray(currentOpt.values) ? currentOpt.values : [];
        const unmatchedBackendValues = [...backendValues];

        // Exact match pass
        const matchedBackendIds = new Set<number>();
        currentVals.forEach((valStr: string) => {
          const trimmedVal = String(valStr).trim().toLowerCase();
          const matchIndex = unmatchedBackendValues.findIndex(
            (ov) => String(ov.value).trim().toLowerCase() === trimmedVal
          );
          if (matchIndex !== -1) {
            matchedBackendIds.add(unmatchedBackendValues[matchIndex].id);
            unmatchedBackendValues.splice(matchIndex, 1);
          }
        });

        // Index-based (edit-in-place) match pass
        currentVals.forEach((valStr: string) => {
          const trimmedVal = String(valStr).trim().toLowerCase();
          const alreadyMatched = Array.from(matchedBackendIds).some((id) => {
            const bv = backendValues.find((x: any) => x.id === id);
            return bv && String(bv.value).trim().toLowerCase() === trimmedVal;
          });
          if (!alreadyMatched && unmatchedBackendValues.length > 0) {
            const matchedVal = unmatchedBackendValues.shift();
            matchedBackendIds.add(matchedVal.id);
          }
        });

        backendValues.forEach((bv: any) => {
          if (!matchedBackendIds.has(bv.id)) {
            deletedOptionValueIds.add(Number(bv.id));
          }
        });
      }
    });

    // --- SECTION 2 & 3: VARIANT MATCHING & AFFECTED SET ---
    const backendOptionsList = Object.entries(backendOptions)
      .map(([name, obj]: any) => ({ name, ...obj }))
      .sort((a, b) => (a.position ?? 999) - (b.position ?? 999));

    const affectedVariantIds = new Set<number>();
    const affectedVariantDetails = new Map<
      number,
      {
        isActive: boolean;
        isDeleted: boolean;
        optionValueMap: Record<string, string>;
      }
    >();

    backendVariants.forEach((v: any) => {
      const vId = Number(v.id);
      if (!vId) return;

      const parsedVals = parseOptionValues(v, backendOptionsList, optionValueIdMap);

      let nulledOptionSlotsCount = 0;
      let nulledValueSlotsCount = 0;
      let activeSlotsCount = 0;
      const optionValueMap: Record<string, string> = {};

      backendOptionsList.forEach((opt: any, optIdx: number) => {
        const optName = opt.name;
        const parsedVal = parsedVals[optIdx];

        const currentOpt = currentOptions.find(
          (o: any) => String(o.name).toLowerCase() === String(optName).toLowerCase()
        );

        if (!currentOpt) {
          nulledOptionSlotsCount++;
        } else {
          const isValueActive = (currentOpt.values || []).some(
            (val: any) => String(val).trim().toLowerCase() === String(parsedVal).trim().toLowerCase()
          );

          if (!isValueActive) {
            nulledValueSlotsCount++;
          } else {
            activeSlotsCount++;
            if (parsedVal) {
              optionValueMap[optName] = parsedVal;
            }
          }
        }
      });

      const isAffected = nulledOptionSlotsCount > 0 || nulledValueSlotsCount > 0;

      if (isAffected) {
        affectedVariantIds.add(vId);

        let isActive = true;
        let isDeleted = false;

        if (activeSlotsCount === 0 || nulledValueSlotsCount > 0) {
          isActive = false;
          isDeleted = true;
        }

        affectedVariantDetails.set(vId, {
          isActive,
          isDeleted,
          optionValueMap,
        });
      }
    });

    // --- SECTION 4: ALL OPTIONS REMOVED ---
    if (!values?.isProductHasVariant) {
      const deactivatedBEVariants = backendVariants.map((v: any) => {
        return {
          id: Number(v.id),
          name: v.name || "",
          barcode: v.barcode || "",
          gtin_number: v.gtin_number || null,
          mpn: v.mpn || "",
          isbn: v.isbn || "",
          ean: v.ean || "",
          sku: v.sku || "",
          isActive: false,
          isDeleted: true,
          position: v.position || 1,
          isTracked: Boolean(v.isTracked),
          option_value: {}, // Null out all slots

          sell_price: {
            ...(v.price?.id ? { id: Number(v.price.id) } : {}),
            value: ensureNonNegative(v.price?.value ?? 0),
          },
          cost_price: {
            ...(v.cost_price?.id ? { id: Number(v.cost_price.id) } : {}),
            value: ensureNonNegative(v.cost_price?.value ?? 0),
          },
          compare_price: {
            ...(v.compare_price?.id ? { id: Number(v.compare_price.id) } : {}),
            value: ensureNonNegative(v.compare_price?.value ?? 0),
          },
          weight: {
            ...(v.weight?.id ? { id: Number(v.weight.id) } : {}),
            value: ensureNonNegative(v.weight?.value ?? 0),
          },
          weight_unit: v.weight?.unit || "KGS",
          reorder_point: Number(v.reorder_point?.api_id ?? v.reorder_point) || 0,

          dimensions: [
            { length: String(ensureNonNegative(v.length?.api_id ?? "")) },
            { width: String(ensureNonNegative(v.width?.api_id ?? "")) },
            { height: String(ensureNonNegative(v.height?.api_id ?? "")) },
          ],
          dimensions_unit: v.dimention_unit?.api_id || values.dimensionUnit || "CM",

          variant_images: v.image ? [{
            id: Number(v.image.id),
            image_position: null,
            image_url: v.image.image_url
          }] : [],
        };
      });

      const singleActiveVariant = {
        barcode: values?.varients_data?.[0]?.barcode || "",
        mpn: "",
        isbn: "",
        ean: values?.varients_data?.[0]?.ean || "",
        sku: values?.varients_data?.[0]?.sku || "",
        isActive: true,
        position: 1,
        isTracked: Boolean(values?.varients_data?.[0]?.isTracked),

        sell_price: {
          ...(backendVariants[0]?.price?.id ? { id: Number(backendVariants[0].price.id) } : {}),
          value: Number(values.salePrice) || 0,
        },
        cost_price: {
          ...(backendVariants[0]?.cost_price?.id ? { id: Number(backendVariants[0].cost_price.id) } : {}),
          value: Number(values.costPrice) || 0,
        },
        compare_price: {
          ...(backendVariants[0]?.compare_price?.id ? { id: Number(backendVariants[0].compare_price.id) } : {}),
          value: Number(values.comparePrice) || 0,
        },
        weight: {
          ...(backendVariants[0]?.weight?.id ? { id: Number(backendVariants[0].weight.id) } : {}),
          value: Number(values.weight) || 0,
        },
        weight_unit: values.weightUnit || "KGS",
        reorder_point: Number(values.reorder_point_value) || 0,

        dimensions: [
          { length: String(values.length ?? "") },
          { width: String(values.width ?? "") },
          { height: String(values.height ?? "") },
        ],
        dimensions_unit: values.dimensionUnit || "CM",
        option_value: {},
        variant_images: (() => {
          const firstImg = values?.selectedImages?.[0]?.url || values?.selectedImages?.[0]?.imageUrl;
          if (!firstImg) return [];
          const imgObj: any = { image_position: null, image_url: firstImg };
          if (mode === "edit" && (values?.selectedImages?.[0]?.id || backendVariants[0]?.image?.id)) {
            imgObj.id = Number(values?.selectedImages?.[0]?.id || backendVariants[0]?.image?.id);
          }
          return [imgObj];
        })(),
      };

      return [singleActiveVariant, ...deactivatedBEVariants];
    }

    // --- SECTION 5: FINAL VARIANT PAYLOAD CONSTRUCTION ---
    // Set 1 — Non-affected variants
    const set1Payload = backendVariants
      .filter((v: any) => {
        const vId = Number(v.id);
        return vId && !affectedVariantIds.has(vId);
      })
      .map((v: any, idx: number) => {
        // Use parseOptionValues (with name-parsing fallback) instead of raw slot data,
        // because backend slot bindings can be corrupt/inconsistent.
        const parsedVals = parseOptionValues(v, backendOptionsList, optionValueIdMap);
        const optionValueMap: Record<string, string> = {};
        backendOptionsList.forEach((opt: any, optIdx: number) => {
          const optName = opt.name;
          const parsedVal = parsedVals[optIdx];
          // Only include if this option still exists in current formik options
          const currentOpt = currentOptions.find(
            (o: any) => String(o.name).toLowerCase() === String(optName).toLowerCase()
          );
          if (currentOpt && parsedVal) {
            optionValueMap[optName] = parsedVal;
          }
        });

        const fv = formikVariantsMap.get(Number(v.id));

        return {
          id: Number(v.id),
          name: v.name || "",
          barcode: fv ? (fv.barcode || "") : (v.barcode || ""),
          gtin_number: v.gtin_number || null,
          mpn: v.mpn || "",
          isbn: v.isbn || "",
          ean: fv ? (fv.ean || "") : (v.ean || ""),
          sku: fv ? (fv.sku || "") : (v.sku || ""),
          isActive: v.isActive !== false,
          isDeleted: false,
          position: v.position ?? idx + 1,
          isTracked: fv ? Boolean(fv.isTracked) : Boolean(v.isTracked),
          option_value: optionValueMap,

          sell_price: {
            ...(v.price?.id ? { id: Number(v.price.id) } : {}),
            value: fv ? ensureNonNegative(fv.price || 0) : ensureNonNegative(v.price?.value ?? 0),
          },
          cost_price: {
            ...(v.cost_price?.id ? { id: Number(v.cost_price.id) } : {}),
            value: fv ? ensureNonNegative(fv.costPrice || 0) : ensureNonNegative(v.cost_price?.value ?? 0),
          },
          compare_price: {
            ...(v.compare_price?.id ? { id: Number(v.compare_price.id) } : {}),
            value: ensureNonNegative(v.compare_price?.value ?? 0),
          },
          weight: {
            ...(v.weight?.id ? { id: Number(v.weight.id) } : {}),
            value: ensureNonNegative(v.weight?.value ?? 0),
          },
          weight_unit: v.weight?.unit || "KGS",
          reorder_point: Number(v.reorder_point?.api_id ?? v.reorder_point) || 0,

          dimensions: [
            { length: String(ensureNonNegative(v.length?.api_id ?? "")) },
            { width: String(ensureNonNegative(v.width?.api_id ?? "")) },
            { height: String(ensureNonNegative(v.height?.api_id ?? "")) },
          ],
          dimensions_unit: v.dimention_unit?.api_id || values.dimensionUnit || "CM",

          variant_images: (() => {
            const fvImgUrl = fv?.variant_image?.url || fv?.variant_image?.imageUrl;
            if (fvImgUrl) {
              return [{
                ...(fv?.variant_image?.id ? { id: Number(fv.variant_image.id) } : (v.image?.id ? { id: Number(v.image.id) } : {})),
                image_position: null,
                image_url: fvImgUrl,
              }];
            }
            return v.image ? [{
              id: Number(v.image.id),
              image_position: null,
              image_url: v.image.image_url
            }] : [];
          })(),
        };
      });

    // Set 2 — New variants (never saved to BE)
    const set2Payload = (values.varients_data || [])
      .filter((v: any) => !v.variant_id)
      .map((v: any, idx: number) => {
        const optionValueMap: Record<string, string> = {};
        (values.options || []).forEach((opt: any, optIdx: number) => {
          const val = v.optionValues?.[optIdx];
          if (opt?.name && val) {
            optionValueMap[opt.name] = val;
          }
        });

        // Rebuild name: "OptionName: OptionValue / OptionName: OptionValue"
        const nameParts: string[] = [];
        (values.options || []).forEach((opt: any, optIdx: number) => {
          const val = v.optionValues?.[optIdx];
          if (opt?.name && val) {
            nameParts.push(`${opt.name}: ${val}`);
          }
        });
        const rebuiltName = nameParts.join(" / ");

        return {
          name: rebuiltName,
          barcode: v.barcode || "",
          gtin_number: null,
          mpn: "",
          isbn: "",
          ean: v.ean || "",
          sku: v.sku || "",
          isActive: true,
          isDeleted: false,
          position: idx + 1,
          isTracked: Boolean(v.isTracked),
          option_value: optionValueMap,

          sell_price: {
            value: Number(v.price) || 0,
          },
          cost_price: {
            value: Number(v.costPrice) || 0,
          },
          compare_price: {
            value: Number(values.comparePrice) || 0,
          },
          weight: {
            value: Number(values.weight) || 0,
          },
          weight_unit: values.weightUnit || "KGS",
          reorder_point: Number(v.reorder_point ?? values.reorder_point_value) || 0,

          dimensions: [
            { length: String(values.length ?? "") },
            { width: String(values.width ?? "") },
            { height: String(values.height ?? "") },
          ],
          dimensions_unit: values.dimensionUnit || "CM",

          variant_images: (() => {
            const imgUrl = v?.variant_image?.url || v?.variant_image?.imageUrl;
            if (!imgUrl) return [];
            return [{ image_position: null, image_url: imgUrl }];
          })(),
        };
      });

    // Set 3 — Affected/deleted variants
    const set3Payload = backendVariants
      .filter((v: any) => {
        const vId = Number(v.id);
        return vId && affectedVariantIds.has(vId);
      })
      .map((v: any) => {
        const vId = Number(v.id);
        const details = affectedVariantDetails.get(vId)!;
        const fv = formikVariantsMap.get(vId);

        return {
          id: vId,
          name: v.name || "",
          barcode: fv ? (fv.barcode || "") : (v.barcode || ""),
          gtin_number: v.gtin_number || null,
          mpn: v.mpn || "",
          isbn: v.isbn || "",
          ean: fv ? (fv.ean || "") : (v.ean || ""),
          sku: fv ? (fv.sku || "") : (v.sku || ""),
          isActive: details.isActive,
          isDeleted: details.isDeleted,
          position: v.position || 1,
          isTracked: fv ? Boolean(fv.isTracked) : Boolean(v.isTracked),
          option_value: details.optionValueMap,

          sell_price: {
            ...(v.price?.id ? { id: Number(v.price.id) } : {}),
            value: fv ? ensureNonNegative(fv.price || 0) : ensureNonNegative(v.price?.value ?? 0),
          },
          cost_price: {
            ...(v.cost_price?.id ? { id: Number(v.cost_price.id) } : {}),
            value: fv ? ensureNonNegative(fv.costPrice || 0) : ensureNonNegative(v.cost_price?.value ?? 0),
          },
          compare_price: {
            ...(v.compare_price?.id ? { id: Number(v.compare_price.id) } : {}),
            value: ensureNonNegative(v.compare_price?.value ?? 0),
          },
          weight: {
            ...(v.weight?.id ? { id: Number(v.weight.id) } : {}),
            value: ensureNonNegative(v.weight?.value ?? 0),
          },
          weight_unit: v.weight?.unit || "KGS",
          reorder_point: Number(v.reorder_point?.api_id ?? v.reorder_point) || 0,

          dimensions: [
            { length: String(ensureNonNegative(v.length?.api_id ?? "")) },
            { width: String(ensureNonNegative(v.width?.api_id ?? "")) },
            { height: String(ensureNonNegative(v.height?.api_id ?? "")) },
          ],
          dimensions_unit: v.dimention_unit?.api_id || values.dimensionUnit || "CM",

          variant_images: (() => {
            const fvImgUrl = fv?.variant_image?.url || fv?.variant_image?.imageUrl;
            if (fvImgUrl) {
              return [{
                ...(fv?.variant_image?.id ? { id: Number(fv.variant_image.id) } : (v.image?.id ? { id: Number(v.image.id) } : {})),
                image_position: null,
                image_url: fvImgUrl,
              }];
            }
            return v.image ? [{
              id: Number(v.image.id),
              image_position: null,
              image_url: v.image.image_url
            }] : [];
          })(),
        };
      });

    // --- SECTION 4: DEDUPLICATION ---
    const activeVariantsMap = new Map<string, any>();
    const inactiveVariantsList: any[] = [];

    const mergedPayload = [...set1Payload, ...set2Payload, ...set3Payload];

    mergedPayload.forEach((v) => {
      if (v.isActive === false || v.isDeleted === true) {
        inactiveVariantsList.push(v);
        return;
      }

      const sortedValues = Object.entries(v.option_value || {})
        .sort(([kA], [kB]) => kA.localeCompare(kB))
        .map(([, val]) => String(val).trim().toLowerCase());

      const key = sortedValues.join("|");

      if (!activeVariantsMap.has(key)) {
        activeVariantsMap.set(key, v);
      } else {
        const existing = activeVariantsMap.get(key);
        if (!existing.id && v.id) {
          activeVariantsMap.set(key, v);
        }
      }
    });

    const finalDeduplicatedPayload = [...activeVariantsMap.values(), ...inactiveVariantsList];

    // --- SECTION 6: PAYLOAD SAFETY CHECK ---
    const safetyCheckedPayload = finalDeduplicatedPayload.filter((v) => {
      if (values.isProductHasVariant) {
        const allSlotsNull = !v.option_value || Object.keys(v.option_value).length === 0;
        if (allSlotsNull) {
          if (v.id) {
            v.isActive = false;
            v.isDeleted = true;
            return true; // Keep to deactivate
          } else {
            return false; // Remove completely
          }
        }
      }
      return true;
    });

    return safetyCheckedPayload;
  };

  const buildSaveVariantPayload = (values: any, editProduct: any) => {
    const backendVariants = Array.isArray(editProduct?.variants) ? editProduct.variants : [];
    const backendOptions = editProduct?.options && typeof editProduct.options === "object" ? editProduct.options : {};
    const currentOptions = Array.isArray(values?.options) ? values.options : [];

    const normalizeKey = (raw: any) =>
      String(raw ?? "").trim().toLowerCase().replace(/[^a-z0-9]+/g, "");

    const backendOptionsList = Object.entries(backendOptions)
      .map(([name, obj]: any, index) => ({ name, ...obj, __index: index }))
      .sort((a: any, b: any) => (a.position ?? 999) - (b.position ?? 999));

    const findBackendOption = (opt: any, index: number, usedIds: Set<number>) => {
      const optId = Number(opt?.id);
      if (optId) {
        const byId = backendOptionsList.find((bo: any) => Number(bo?.id) === optId);
        if (byId) return byId;
      }

      const byName = backendOptionsList.find((bo: any) =>
        !usedIds.has(Number(bo?.id)) &&
        normalizeKey(bo?.name) === normalizeKey(opt?.name)
      );
      if (byName) return byName;

      return backendOptionsList.find((bo: any) =>
        !usedIds.has(Number(bo?.id)) &&
        Number(bo?.position ?? bo.__index + 1) === Number(opt?.position ?? index + 1)
      );
    };

    const usedBackendOptionIds = new Set<number>();
    const currentOptionDefs = currentOptions
      .filter((opt: any) => String(opt?.name ?? "").trim())
      .map((opt: any, optIndex: number) => {
        const backendOpt = findBackendOption(opt, optIndex, usedBackendOptionIds);
        if (backendOpt?.id) usedBackendOptionIds.add(Number(backendOpt.id));

        const backendValues = Array.isArray(backendOpt?.values) ? [...backendOpt.values] : [];
        const currentValues = (Array.isArray(opt?.values) ? opt.values : [])
          .map((v: any) => String(v ?? "").trim())
          .filter(Boolean);
        const unmatchedBackendValues = [...backendValues];
        const valueIds = opt?.value_ids && typeof opt.value_ids === "object" ? opt.value_ids : {};

        const exactMatches = currentValues.map((value: string) => {
          const directId = valueIds[value];
          if (directId) {
            const directIdx = unmatchedBackendValues.findIndex((bv: any) => Number(bv?.id) === Number(directId));
            if (directIdx !== -1) unmatchedBackendValues.splice(directIdx, 1);
            return { value, id: Number(directId) };
          }

          const matchIndex = unmatchedBackendValues.findIndex(
            (bv: any) => normalizeKey(bv?.value) === normalizeKey(value)
          );

          if (matchIndex !== -1) {
            const match = unmatchedBackendValues[matchIndex];
            unmatchedBackendValues.splice(matchIndex, 1);
            return { value, id: Number(match.id) };
          }

          return { value, id: null };
        });

        const valuesWithIds = exactMatches.map((item: any) => {
          if (item.id) return item;
          const renamedBackendValue = unmatchedBackendValues.shift();
          return renamedBackendValue?.id ? { ...item, id: Number(renamedBackendValue.id) } : item;
        });

        return {
          id: backendOpt?.id ? Number(backendOpt.id) : (opt?.id ? Number(opt.id) : null),
          name: String(opt.name).trim(),
          key: backendOpt?.id ? `id:${Number(backendOpt.id)}` : `name:${normalizeKey(opt.name)}`,
          values: valuesWithIds.map((v: any) => ({
            ...v,
            key: v.id ? `id:${Number(v.id)}` : `value:${normalizeKey(v.value)}`,
          })),
        };
      });

    const valueBelongsToOption = (optionDef: any, value: any) => {
      const normalized = normalizeKey(value);
      if (!normalized) return false;
      return optionDef.values.some((v: any) => normalizeKey(v.value) === normalized);
    };

    const getRowValueForOption = (row: any, optionDef: any, optIndex: number, usedIndexes: Set<number>) => {
      const optionValues = Array.isArray(row?.optionValues) ? row.optionValues : [];
      const indexedValue = optionValues[optIndex];
      if (valueBelongsToOption(optionDef, indexedValue)) {
        usedIndexes.add(optIndex);
        return indexedValue;
      }

      const foundIndex = optionValues.findIndex((candidate: any, candidateIndex: number) =>
        !usedIndexes.has(candidateIndex) && valueBelongsToOption(optionDef, candidate)
      );

      if (foundIndex !== -1) {
        usedIndexes.add(foundIndex);
        return optionValues[foundIndex];
      }

      usedIndexes.add(optIndex);
      return indexedValue;
    };

    const buildRowCombination = (row: any) => {
      const usedIndexes = new Set<number>();
      const pairs = currentOptionDefs.map((optionDef: any, optIndex: number) => {
        const rawValue = getRowValueForOption(row, optionDef, optIndex, usedIndexes);
        const valueDef = optionDef.values.find((v: any) => normalizeKey(v.value) === normalizeKey(rawValue));
        return {
          optionName: optionDef.name,
          value: String(rawValue ?? "").trim(),
          isActiveValue: !!valueDef,
          key: `${optionDef.key}:${valueDef?.key ?? `value:${normalizeKey(rawValue)}`}`,
        };
      });

      const optionValueMap = pairs.reduce((acc: Record<string, string>, pair: any) => {
        if (pair.optionName && pair.value && pair.isActiveValue) acc[pair.optionName] = pair.value;
        return acc;
      }, {});

      return {
        key: pairs.map((pair: any) => pair.key).sort().join("|"),
        optionValueMap,
        complete: currentOptionDefs.length > 0 && Object.keys(optionValueMap).length === currentOptionDefs.length,
        name: pairs
          .filter((pair: any) => pair.optionName && pair.value)
          .map((pair: any) => `${pair.optionName}: ${pair.value}`)
          .join(" / "),
      };
    };

    const getBackendSlotPairs = (variant: any) =>
      [1, 2, 3].flatMap((slotNum) => {
        const slot = variant?.[`platform_product_option_value${slotNum}`];
        if (!slot) return [];

        const optionId = Number(slot?.platform_product_option);
        const valueId = Number(slot?.id);
        const optionName = slot?.option_name || backendOptionsList.find((opt: any) => Number(opt?.id) === optionId)?.name;
        const value = slot?.value;

        const optionDef = currentOptionDefs.find((opt: any) =>
          (optionId && opt.id === optionId) || normalizeKey(opt.name) === normalizeKey(optionName)
        );

        if (!optionDef) {
          return [{
            key: `deleted-option:${optionId || normalizeKey(optionName)}:${valueId || normalizeKey(value)}`,
            optionName,
            value,
            isCurrent: false,
          }];
        }

        const valueDef = optionDef.values.find((v: any) =>
          (valueId && v.id === valueId) || normalizeKey(v.value) === normalizeKey(value)
        );

        return [{
          key: `${optionDef.key}:${valueDef?.key ?? `deleted-value:${valueId || normalizeKey(value)}`}`,
          optionName: optionDef.name,
          value: valueDef?.value ?? value,
          isCurrent: Boolean(valueDef),
        }];
      });

    const buildBackendCombination = (variant: any) => {
      const currentPairs = getBackendSlotPairs(variant).filter((pair: any) => pair.isCurrent);
      const optionValueMap = currentPairs.reduce((acc: Record<string, string>, pair: any) => {
        if (pair.optionName && pair.value) acc[pair.optionName] = String(pair.value).trim();
        return acc;
      }, {});

      return {
        key: currentPairs.map((pair: any) => pair.key).sort().join("|"),
        optionValueMap,
        complete: currentOptionDefs.length > 0 && currentPairs.length === currentOptionDefs.length,
      };
    };

    const backendById = new Map<number, any>();
    const backendByCombo = new Map<string, any>();
    backendVariants.forEach((variant: any) => {
      const id = Number(variant?.id);
      if (!id) return;
      backendById.set(id, variant);
      const combo = buildBackendCombination(variant);
      if (combo.complete && combo.key && !backendByCombo.has(combo.key)) {
        backendByCombo.set(combo.key, variant);
      }
    });

    const buildImagesPayload = (row: any, backendVariant: any) => {
      const rowImgUrl = row?.variant_image?.url || row?.variant_image?.imageUrl;
      if (rowImgUrl) {
        return [{
          ...(row?.variant_image?.id ? { id: Number(row.variant_image.id) } : (backendVariant?.image?.id ? { id: Number(backendVariant.image.id) } : {})),
          image_position: null,
          image_url: rowImgUrl,
        }];
      }

      return backendVariant?.image ? [{
        id: Number(backendVariant.image.id),
        image_position: null,
        image_url: backendVariant.image.image_url,
      }] : [];
    };

    const buildVariantPayload = (row: any, backendVariant: any, combo: any, position: number, deleted = false) => ({
      ...(backendVariant?.id ? { id: Number(backendVariant.id) } : (row?.variant_id ? { id: Number(row.variant_id) } : {})),
      name: deleted ? (backendVariant?.name || combo.name || "") : (combo.name || backendVariant?.name || ""),
      barcode: row?.barcode ?? backendVariant?.barcode ?? "",
      gtin_number: backendVariant?.gtin_number || null,
      mpn: backendVariant?.mpn || "",
      isbn: backendVariant?.isbn || "",
      ean: row?.ean ?? backendVariant?.ean ?? "",
      sku: row?.sku ?? backendVariant?.sku ?? "",
      isActive: !deleted,
      isDeleted: deleted,
      position,
      isTracked: row?.isTracked !== undefined ? Boolean(row.isTracked) : Boolean(backendVariant?.isTracked),
      option_value: combo.optionValueMap || {},
      sell_price: {
        ...(backendVariant?.price?.id ? { id: Number(backendVariant.price.id) } : {}),
        value: (row?.price === "" || row?.price === null || row?.price === undefined) ? "" : ensureNonNegative(row.price),
      },
      cost_price: {
        ...(backendVariant?.cost_price?.id ? { id: Number(backendVariant.cost_price.id) } : {}),
        value: (row?.costPrice === "" || row?.costPrice === null || row?.costPrice === undefined)
          ? ""
          : ensureNonNegative(row.costPrice),
      },
      compare_price: {
        ...(backendVariant?.compare_price?.id ? { id: Number(backendVariant.compare_price.id) } : {}),
        value: ensureNonNegative(backendVariant?.compare_price?.value ?? values.comparePrice ?? 0),
      },
      weight: {
        ...(backendVariant?.weight?.id ? { id: Number(backendVariant.weight.id) } : {}),
        value: ensureNonNegative(backendVariant?.weight?.value ?? values.weight ?? 0),
      },
      weight_unit: backendVariant?.weight?.unit || values.weightUnit || "KGS",
      reorder_point: Number(row?.reorder_point ?? backendVariant?.reorder_point?.api_id ?? backendVariant?.reorder_point ?? values.reorder_point_value ?? 0) || 0,
      dimensions: [
        { length: String(backendVariant?.length?.api_id ?? values.length ?? "") },
        { width: String(backendVariant?.width?.api_id ?? values.width ?? "") },
        { height: String(backendVariant?.height?.api_id ?? values.height ?? "") },
      ],
      dimensions_unit: backendVariant?.dimention_unit?.api_id || values.dimensionUnit || "CM",
      variant_images: buildImagesPayload(row, backendVariant),
    });

    if (values?.isProductHasVariant) {
      const usedBackendIds = new Set<number>();
      const activePayloadByCombo = new Map<string, any>();

      (values.varients_data || []).forEach((row: any, rowIndex: number) => {
        const combo = buildRowCombination(row);
        const hasAtLeastOneVal = Object.keys(combo.optionValueMap || {}).length > 0;
        if (!hasAtLeastOneVal || !combo.key) return;

        const backendVariant = row?.variant_id
          ? backendById.get(Number(row.variant_id))
          : backendByCombo.get(combo.key);
        const payload = buildVariantPayload(row, backendVariant, combo, rowIndex + 1, false);
        const rowKey = row.variant_id ? `id:${row.variant_id}` : `index:${rowIndex}`;
        const existingPayload = activePayloadByCombo.get(rowKey);

        if (!existingPayload || (!existingPayload.id && payload.id)) {
          activePayloadByCombo.set(rowKey, payload);
        }

        if (backendVariant?.id) usedBackendIds.add(Number(backendVariant.id));
      });

      const deletedPayload = backendVariants.flatMap((variant: any) => {
        const variantId = Number(variant?.id);
        if (!variantId || usedBackendIds.has(variantId)) return [];

        const combo = buildBackendCombination(variant);
        return [buildVariantPayload(null, variant, combo, Number(variant.position ?? 1), true)];
      });

      const activePayload = [...activePayloadByCombo.values()].filter((payload: any) => {
        const hasOptionSlots = payload.option_value && Object.keys(payload.option_value).length > 0;
        if (hasOptionSlots) return true;

        if (payload.id) {
          payload.isActive = false;
          payload.isDeleted = true;
          return true;
        }

        return false;
      });

      return [...activePayload, ...deletedPayload];
    } else {
      const singleRow = values?.varients_data?.[0] || {};
      const apiV0 = backendVariants?.[0];

      return [
        {
          ...(mode === "edit" && singleRow?.variant_id
            ? { id: Number(singleRow.variant_id) }
            : {}),

          name: apiV0?.name ?? values?.name ?? 'Default',
          barcode: (singleRow?.barcode !== undefined && singleRow?.barcode !== null) ? singleRow.barcode : (apiV0?.barcode || ''),
          mpn: apiV0?.mpn || '',
          isbn: apiV0?.isbn || '',
          ean: (singleRow?.ean !== undefined && singleRow?.ean !== null) ? singleRow.ean : (apiV0?.ean || ''),
          sku: singleRow?.sku || apiV0?.sku || '',
          isActive: true,
          isTracked: Boolean(singleRow?.isTracked),
          position: 1,

          gtin_number: null,

          sell_price: {
            id: apiV0?.price?.id ? Number(apiV0.price.id) : Math.floor(10000000 + Math.random() * 90000000),
            value: Number(values?.salePrice) || 0,
          },

          cost_price: {
            id: apiV0?.cost_price?.id ? Number(apiV0.cost_price.id) : Math.floor(10000000 + Math.random() * 90000000),
            value: Number(values?.costPrice) || 0,
          },

          compare_price: {
            id: apiV0?.compare_price?.id ? Number(apiV0.compare_price.id) : Math.floor(10000000 + Math.random() * 90000000),
            value: Number(values?.comparePrice) || 0,
          },

          weight: {
            id: apiV0?.weight?.id ? Number(apiV0.weight.id) : Math.floor(10000000 + Math.random() * 90000000),
            value: Number(values?.weight) || 0,
          },
          weight_unit: values?.weightUnit || 'KGS',

          reorder_point: Number(values?.reorder_point_value) || 0,

          dimensions: [
            { length: String(values.length ?? "") },
            { width: String(values.width ?? "") },
            { height: String(values.height ?? "") },
          ],
          dimensions_unit: values.dimensionUnit || "",

          variant_images: (() => {
            const imgUrl = values?.selectedImages?.[0]?.url || values?.selectedImages?.[0]?.imageUrl;
            if (!imgUrl) return [];
            const imgObj: any = { image_position: null, image_url: imgUrl };
            const imgId = values?.selectedImages?.[0]?.id || apiV0?.image?.id;
            if (mode === "edit" && imgId) imgObj.id = Number(imgId);
            return [imgObj];
          })(),
        },
      ];
    }
  };

  const buildVariantCombinationKeyFromPayload = (payload: any) =>
    Object.entries(payload?.option_value || {})
      .map(([optionName, value]) => `${String(optionName).trim().toLowerCase()}:${String(value ?? "").trim().toLowerCase()}`)
      .sort()
      .join("|");

  const buildVariantCombinationKeyFromRow = (row: any, options: any[] = []) => {
    const optionValueMap = (options || []).reduce((acc: Record<string, string>, opt: any, index: number) => {
      const value = row?.optionValues?.[index];
      if (opt?.name && value) acc[String(opt.name)] = String(value);
      return acc;
    }, {});

    return buildVariantCombinationKeyFromPayload({ option_value: optionValueMap });
  };

  const buildOptionsValuesPayloadForEdit = (formikOptions: any[], editProduct: any) => {
    const backendOptions = editProduct?.options || {};
    
    return (formikOptions || [])
      .filter((opt) => String(opt?.name ?? "").trim())
      .map((opt) => {
        const name = String(opt.name).trim();
        
        let origOption: any = null;
        if (opt.id) {
          origOption = Object.values(backendOptions).find((bo: any) => Number(bo?.id) === Number(opt.id));
        } else {
          origOption = backendOptions[name.toLowerCase()] || backendOptions[name];
        }
        
        const origValues = Array.isArray(origOption?.values) ? origOption.values : [];
        const currentValues = Array.isArray(opt.values) ? opt.values : [];
        const unmatchedBackendValues = [...origValues];
        
        // Exact match pass
        const matchedBackendIds = new Set<number>();
        const exactMatches = currentValues.map((valStr: any) => {
          const trimmedVal = String(valStr).trim().toLowerCase();
          const matchIndex = unmatchedBackendValues.findIndex(
            (ov) => String(ov.value).trim().toLowerCase() === trimmedVal
          );
          if (matchIndex !== -1) {
            matchedBackendIds.add(unmatchedBackendValues[matchIndex].id);
            const match = unmatchedBackendValues[matchIndex];
            unmatchedBackendValues.splice(matchIndex, 1);
            return { value: String(valStr).trim(), id: match.id };
          }
          return { value: String(valStr).trim(), id: null };
        });
        
        // Index-based (edit-in-place) match pass for remaining
        const finalValues = exactMatches.map((item) => {
          if (item.id !== null) {
            return { id: item.id, value: item.value };
          }
          if (unmatchedBackendValues.length > 0) {
            const origVal = unmatchedBackendValues.shift();
            return { id: origVal?.id, value: item.value };
          }
          return { value: item.value };
        }).filter(v => v.value !== "");
        
        return {
          ...(opt.id ? { id: Number(opt.id) } : {}),
          name,
          position: opt.position ?? 1,
          values: finalValues,
        };
      })
      .filter((opt) => opt.values.length > 0);
  };

  const buildAdjustInventoryPayload = (
    values: any,
    productId: number,
    variantIds: number[]
  ) => {
    const singleVariantId = Number(variantIds?.[0]);
    const sku = values?.varients_data?.[0]?.sku || "";

    return {
      convert: false,
      items: (values.inventory || [])
        .filter((row: any) => Boolean(row?.id))
        .map((row: any) => ({
          variant_id: singleVariantId,
          product_id: Number(productId),
          sku,
          quantity: Number(row?.quantity) || 0,
          warehouse_id: Number(row?.id),
        })),
    };
  };

  const isEmptyRequiredValue = (type: string, val: any) => {
    switch (type) {
      case "MULTISELECT":
        return !Array.isArray(val) || val.length === 0;
      case "SELECT":
        return val === "" || val === null || val === undefined;
      case "CHECKBOX":
        // required checkbox usually means it must be checked
        return parseCheckboxValue(val) !== true;
      // TEXT/NUMBER/EMAIL/URL/DATE/DATE_TIME/TIME/etc
      default:
        if (val === null || val === undefined) return true;
        if (typeof val === "string") return val.trim() === "";
        return false; // numbers like 0 are valid
    }
  };

  const validateRequiredCustomFields = (values: any, customFieldsList: any[]) => {
    const requiredFields = (customFieldsList || []).filter(
      (f: any) => f?.owner === "PRODUCT" && f?.isActive && f?.isRequired
    );

    const errors: string[] = [];
    for (const f of requiredFields) {
      const fieldId = String(f.id);
      const val = values?.custom_fields?.[fieldId] ?? values?.custom_fields?.[Number(fieldId)];
      if (isEmptyRequiredValue(f.input_type, val)) {
        errors.push(`${f.display_name} is required`);
      }
    }
    return errors;
  };

  const handleSubmit = async (values: any, actions: any) => {
    if (isSavingProductRef.current) return;
    isSavingProductRef.current = true;
    setIsSavingProduct(true);
    actions.setSubmitting(true);

    let cooldown = 0;

    try {
      // Validations
      if (!values?.name?.trim()) {
        toast.error("Product Name is required");
        cooldown = 4000;
        return;
      }
      if (!values?.isProductHasVariant) {
        if (values?.varients_data[0]?.sku?.trim() === "") {
          toast.error("SKU is required for variants");
          cooldown = 4000;
          return;
        }
        // if (values?.varients_data[0]?.barcode?.trim() === "") {
        //   toast.error("Barcode is required for variants");
        //   return;
        // }
      }
      // if (!Array.isArray(values?.selectedImages) || values.selectedImages.length === 0) {
      //   toast.error("Product Media is required");
      //   return;
      // }


      if (!values?.type?.trim()) {
        toast.error("Type is required");
        cooldown = 4000;
        return;
      }
      if (!values?.isProductHasVariant) {
        if (values?.salePrice === "" || values?.salePrice === null || values?.salePrice === undefined) {
          toast.error("Sale price is required");
          cooldown = 4000;
          return;
        }
        if (Number(values.salePrice) < 0) {
          toast.error("Sale price cannot be negative");
          cooldown = 4000;
          return;
        }
      }

      if (values?.isProductHasVariant) {
        const missingVariantPrice = (values?.varients_data || []).some((v: any) => v.price === "" || v.price === null || v.price === undefined);
        if (missingVariantPrice) {
          toast.error("Price is required for all variants");
          cooldown = 4000;
          return;
        }
      }

      const cfErrors = validateRequiredCustomFields(values, customFieldsList);
      if (cfErrors.length) {
        toast.error(cfErrors[0]); // show first one (or join them)
        cooldown = 4000;
        return;
      }

      // CREATE & UPDATE PRODUCT
      const payload = buildCreateProductPayload(values, mode);
      const res = mode === "edit" ? await dispatch(
        updateProductAsync({
          id: Number(resolvedProductId), data: payload,
        })).unwrap() : await dispatch(createProductAsync(payload)).unwrap();
      const status = Number(res?.status);
      const apiMsg = res?.message || res?.errors?.detail;
      if (status !== 200 && status !== 201) {
        toast.error(apiMsg || "Something went wrong");
        return;
      }
      const productId = mode === "edit" ? Number(resolvedProductId) : Number(res?.data?.id);
      let resVariantId = res?.data?.variants?.[0];
      if (!productId) {
        toast.error("Product created but productId missing in response");
        return;
      }

      // CUSTOM FIELDS SECTION 
      const cfPayload = mode === "edit" ? buildCustomFieldsPayloadForEdit(
        values.custom_fields, customFieldsList, values.product_custom_fields_raw
      ) : buildCustomFieldsPayloadForCreate(values.custom_fields, customFieldsList);

      const cfRes: any = await dispatch(createProductCustomFieldAsync({ productId, data: cfPayload })).unwrap();
      const cfStatus = Number(cfRes?.status);
      if (cfStatus !== 200 && cfStatus !== 201) {
        toast.error(getApiErrorMessage(cfRes, "Failed to save custom fields"));
        return; // fail-fast
      }

      // OPTION & VARIANT SECTIONS (fired sequentially for Edit mode)
      if (mode === "edit") {
        const editProductData: any = getEditData;
        const optionsPayload = buildOptionsValuesPayloadForEdit(values.options, editProductData);
        const hadBackendOptions = Boolean(
          editProductData?.options &&
          typeof editProductData.options === "object" &&
          Object.keys(editProductData.options).length
        );

        // 1. Save options first so they exist in the DB for the product
        if (optionsPayload.length || hadBackendOptions) {
          const optRes: any = await dispatch(
            createOptionNameAsync({ productId, data: optionsPayload })
          ).unwrap();
          const optStatus = Number(optRes?.status);
          if (optRes && optStatus !== 200 && optStatus !== 201) {
            toast.error(getApiErrorMessage(optRes, "Failed to save options"));
            return;
          }
        }

        // 2. Build the variant payload using current options (after options have been successfully saved)
        const variantsPayload = buildSaveVariantPayload(values, editProductData);

        // 3. Save variants
        const vRes: any = await dispatch(
          SaveVariantAsync({ product_id: productId, payload: variantsPayload })
        ).unwrap();

        const vStatus = Number(vRes?.status);
        if (vRes && vStatus !== 200 && vStatus !== 201) {
          toast.error(getApiErrorMessage(vRes, "Failed to save variants"));
          return;
        }

        if (vRes?.data && Array.isArray(vRes.data)) {
          resVariantId = vRes.data[0];

          const responseIdByCombination = new Map<string, number>();
          variantsPayload.forEach((variantPayload: any, payloadIndex: number) => {
            if (variantPayload?.isActive === false || variantPayload?.isDeleted === true) return;

            const responseId = variantPayload?.id || vRes.data[payloadIndex];
            const combinationKey = buildVariantCombinationKeyFromPayload(variantPayload);
            if (responseId && combinationKey) {
              responseIdByCombination.set(combinationKey, Number(responseId));
            }
          });

          const updatedVarientsData = (values.varients_data || []).map((v: any) => {
            if (!v.variant_id) {
              const combinationKey = buildVariantCombinationKeyFromRow(v, values.options || []);
              const newId = responseIdByCombination.get(combinationKey);
              if (newId) return { ...v, variant_id: newId };
            }
            return v;
          });

          actions.setFieldValue("varients_data", updatedVarientsData);
        }
      } else {
        // Create mode: options are already saved via createProductAsync payload.
      }

      // INVENTORY ADJUSTMENT SECTION (only if tracked inventory exists)
      const isTrackedInventory = values?.varients_data?.[0]?.isTracked && values?.inventory?.length > 0;
      // single-product inventory adjust only in edit mode
      if (isTrackedInventory) {
        if (!resVariantId) {
          toast.error("Variant id missing for inventory adjustment");
          return;
        }
        const adjustPayload = buildAdjustInventoryPayload(values, Number(productId), [resVariantId]);
        if (adjustPayload.items.length) {
          const invAdjustRes: any = await dispatch(adjustVariantInventoryAsync({ data: adjustPayload })).unwrap();
          const invAdjustStatus = Number(invAdjustRes?.status);
          if (invAdjustStatus !== 200 && invAdjustStatus !== 201) {
            toast.error(getApiErrorMessage(invAdjustRes, "Failed to adjust inventory"));
            return;
          }
        }
      }

      toast.success(mode === "edit" ? "Product updated successfully." : "Product created successfully.");
      if (mode !== "edit") {
        const platformIdForRoute = Number(currentPlatformId);
        if (!platformIdForRoute || Number.isNaN(platformIdForRoute)) {
          toast.error(
            "Product created but platform id is missing; open the product from the product list."
          );
          return;
        }
        navigate(
          `/update-product/platform/${platformIdForRoute}/productId/${productId}`,
          {
            replace: true,
            state: { mode: "edit", platformId: platformIdForRoute },
          }
        );
      }
    } catch (error: any) {
      const err = error?.data ?? error;
      toast.error(err?.errors?.detail || err?.message || "Something went wrong");
    } finally {
      if (cooldown > 0) {
        setTimeout(() => {
          isSavingProductRef.current = false;
          setIsSavingProduct(false);
          actions.setSubmitting(false);
        }, cooldown);
      } else {
        isSavingProductRef.current = false;
        setIsSavingProduct(false);
        actions.setSubmitting(false);
      }
    }
  };

  return (
    <div className="variantScope page page--create-product d-flex flex-column flex-column-fluid">
      {/* Loader overlay (covers whole page area, not pushing content) */}
      {isPageLoading && (
        <div className="variantScope__loader">
          <div className="text-center my-2">
            <Loader variant="section" />
          </div>
        </div>
      )}

      {/* ONE scroll container */}
      <div className="variantScope__scroll">
        {/* Sticky header INSIDE scroll container */}
        <div className="variantScope__header">
          <div className="d-flex align-items-center w-100 px-4">
            <div className="d-flex flex-column">
              <PremiumBreadcrumb
                items={[
                  { label: currentPlatformName, to: backUrl },
                  { label: mode === 'edit' ? 'Update Product' : 'Create Product' },
                ]}
              />
              <span className="fw-bold" style={{ fontSize: 16 }}>
                {mode === "edit" ? "Update Product" : "Create Product"}
              </span>
            </div>

            <div className="ms-auto d-flex align-items-center gap-3">
              <button
                type="button"
                className="btn btn-sm btn-light fw-bold"
                onClick={() => navigate(backUrl)}
                disabled={isSavingProduct}
              > Cancel
              </button>

              {/* same size like before */}
              <button
                type="submit"
                form="kt_ecommerce_add_product_form"
                className="btn btn-sm fw-bold btn-primary"
                disabled={isSavingProduct}
              >
                {isSavingProduct ? "Saving..." : (mode === "edit" ? "Update Product" : "Create Product")}
              </button>
            </div>
          </div>
        </div>


        {/* Page content */}
        <div className="px-4 pb-6">
          <Formik
            initialValues={mode === "edit" ? editInitialValues : initialValues}
            enableReinitialize
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, handleChange, values, setFormikState }) => (
              <form
                id="kt_ecommerce_add_product_form"
                className="form d-flex flex-column fv-plugins-bootstrap5 fv-plugins-framework"
                onSubmit={handleSubmit}
                onKeyDownCapture={(e) => {
                  if (e.key !== "Enter") return;

                  const target = e.target as HTMLElement;
                  const tag = target?.tagName?.toLowerCase();
                  const isTextarea = tag === "textarea";
                  const isSubmitButton =
                    tag === "button" &&
                    (target as HTMLButtonElement).type === "submit";
                  // Rich text editors (e.g. CKEditor) use a contenteditable div and
                  // must handle Enter themselves to insert a new line/paragraph.
                  const isRichTextEditor =
                    target?.isContentEditable ||
                    !!target?.closest?.(".ck-editor__editable");

                  if (isTextarea || isSubmitButton || isRichTextEditor) return;

                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <div className="d-flex flex-column gap-4">
                  <FirstPhase
                    values={values}
                    handleChange={handleChange}
                    setFormikState={setFormikState}
                    mode={mode}
                    getEditData={getEditData}
                    productId={Number(productId)}
                  />

                  <VariantComponent
                    values={values}
                    setFormikState={setFormikState}
                    mode={mode}
                    productId={productId}
                    editInitialValues={getEditData}
                    productRowData={rowData}
                    currentPlatformId={currentPlatformId}
                  />

                  <ProductMediaSection
                    values={values}
                    setFormikState={setFormikState}
                    mode={mode}
                    productId={Number(productId)}
                  />

                  <SecondPhase
                    values={values}
                    handleChange={handleChange}
                    setFormikState={setFormikState}
                    mode={mode}
                    editInventoryData={editInventoryData}
                    platformId={currentPlatformId}
                  />

                  <ProductCustomFields
                    values={values}
                    setFormikState={setFormikState}
                    mode={mode}
                    productRowData={rowData}
                  />
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default OldCreateProduct 
